export const getEmailFromUsername = (username) => {
    let splitUsername = username.split("_")

    return splitUsername[1]
}